module.exports = __webpack_public_path__ + "img/team-member.c5350a6e.svg";